<template>
  <div id="home">
    <div v-show="!show2" class="mainWrap">
      <div class="main1">
        <div class="selectWrap">
          <img v-if="myhadletx" class="userImg1" :src="myhadletx + '?vs=' + nowTime">
          <p v-else class="userImg">{{ downvalue ? downvalue.slice(0, 2) : '-' }}</p>
          <div @click="showzhWrap = true">{{ nowusername }} <img class="vector" src="../assets/vector.png"></div>
        </div>
      </div>
      <div class="main2">
        <div class="sm_Wrap">
          <van-search class="myipt" v-model="telephonevalue.CustomerTelephone" placeholder="搜索内容" @input="listchat"/>
          <img src="../assets/sm_icon1.png" @click="showshaixuanDialog">
          <img src="../assets/sm_icon2.png" @click="showhuasetingDialogFn">
          <img src="../assets/sm_icon3.png" v-if="downvalList.length > 0" @click="showhuihuaDialog">
        </div>
        <div class="plWrap">
          <div class="vans-button">
            <van-button :disabled="downvalList.length === 0" :type="checked === false ? 'info' : '11'" size="small" @click="futerDataFn('全部')">全部</van-button>
            <van-button :disabled="downvalList.length === 0" :type="checked === true ? 'info' : '11'" size="small" @click="futerDataFn('未读')">未读</van-button>
          </div>
          <p @click="plFn" :class="qiehuancheckbox === true ? 'grenn' : ''">{{ plText }}</p>
        </div>
      </div>
      <div class="main3">
        <ul class="infoList" id="infoList">
          <van-checkbox-group v-model="result" ref="checkboxGroup" checked-color="#177EE5" @change="changegroup">
            <li v-for="(item, index) in telephonevalList" :key="index" :class="item.id === chatListval.CustomerTelephoneId ? 'isxhbox' : ''">
              <van-checkbox :name="item.id" checked-color="#177EE5" v-show="qiehuancheckbox"></van-checkbox>
              <img v-if="item.headurl" class="userImg2" :src="item.headurl + '?vs=' + nowTime">
              <p v-else class="userImg">{{ item.name ? item.name.slice(0, 1) : '-' }}</p>
              <div style="width:216px" @click="huoqucontent(item, index)">
                <p class="infoName">
                  <span class="names">{{ item.name ? item.name : item.telephone }}</span>
                  <!-- <i class="el-icon-more" @mouseenter="showshanchuhuihuaWrap(item)" @mouseleave="hideshanchuhuihuaWrap(item)"></i> -->
                </p>
                <p v-if="item.remark" class="userremark">( {{item.remark}} )</p>
                <p class="infoMsg">
                  <span>{{ item.content }}</span>
                  <b class="redreidw redreidw1" v-show="item.noreadcount > 0">{{ item.noreadcount }}</b>
                </p>
                <p v-show="shijicheckList.indexOf('1') !== -1"><img src="../assets/infomsgicon1.png"><span v-show="item.mobile">+ {{ item.mobileareacode }} {{ item.mobile }}</span></p>
                <p v-show="shijicheckList.indexOf('2') !== -1"><img src="../assets/infomsgicon2.png">{{ item.email }}</p>
                <p v-show="shijicheckList.indexOf('3') !== -1"><img src="../assets/infomsgicon3.png">{{ item.countryname }}</p>
                <p v-show="shijicheckList.indexOf('4') !== -1"><img src="../assets/infomsgicon4.png">{{ item.companyname }}</p>
                <van-tag v-show="shijicheckList.indexOf('5') !== -1" type="info" class="smTags" v-for="items in item.TagAll" :key="items.index">{{ items.name }}</van-tag>
              </div>
            </li>
          </van-checkbox-group>
        </ul>
      </div>
    </div>
    <div class="isEmpit" v-show="show2">
      <img src="../assets/kong.png">
      <p>请在PC端连接或绑定号码</p>
    </div>
    <van-tabbar v-model="active" active-color="#177EE5" inactive-color="#000" @change="changetabbar">
      <!-- info="1" -->
      <van-tabbar-item icon="smile-o">聊天对话</van-tabbar-item>
      <van-tabbar-item icon="user">个人中心</van-tabbar-item>
    </van-tabbar>
    <van-popup id="liebiaoshezhi" v-model="huihuasetingDialog" get-container="body" >
      <div class="fanyidialogitem1"><span>列表设置</span><img src="../assets/guanbi.png" @click="huihuasetingDialog = false"></div>
      <van-checkbox-group class="mycheckList" v-model="checkList" checked-color="#fff">
        <van-checkbox checked-color="#177EE5" name="1">显示手机号</van-checkbox>
        <van-checkbox checked-color="#177EE5" name="2">显示邮箱</van-checkbox>
        <van-checkbox checked-color="#177EE5" name="3">显示国家</van-checkbox>
        <van-checkbox checked-color="#177EE5" name="4">显示公司</van-checkbox>
        <van-checkbox checked-color="#177EE5" name="5">显示标签</van-checkbox>
      </van-checkbox-group>
      <div class="jjWraps">
        <van-button type="info" size="small"  @click="huihualiebiaoShezhi">确定</van-button>
        <van-button size="small" style="margin-left: 20px;" @click="huihuasetingDialog = false">取消</van-button>
      </div>
    </van-popup>
    <van-popup class="TagDialog" v-model="shaixuanDialog">
      <div class="fanyidialogitem1"><span>筛选标签</span><img src="../assets/guanbi.png" @click="shaixuanDialog = false"></div>
      <div class="tagsWraps">
        <van-tag :type="shaixuanTagId === item.Id ? 'info' : ''"  v-for="item in magg" :key="item.Id" @click="checkedTagFn2(item)">{{ item.Name }}</van-tag>
      </div>
      <div class="jjWraps">
        <van-button type="info" size="small" @click="shaixuanButton2">确定</van-button>
        <van-button size="small" style="margin-left: 20px;" @click="clearTagary">重置</van-button>
      </div>
    </van-popup>
    <van-popup class="TagDialog" v-model="huihuaDialog">
      <div class="fanyidialogitem1"><span>创建会话</span><img src="../assets/guanbi.png" @click="huihuaDialog = false"></div>
      <div class="tagsWraps">
        <div class="shoujihaoWrap">
          <span @click="showPicker = true">+ {{ WhatsAppCustomerTelephonesAddData.AreaCode }}</span>
          <van-field class="van-fieldWrap" v-model="WhatsAppCustomerTelephonesAddData.Telephone" />
        </div>
        <p class="red"><span v-show="redTips">无效号码，无法创建会话</span></p>
      </div>
      <div class="jjWraps">
        <van-button type="info" size="small" @click="createWhatsappNumber">确定</van-button>
        <van-button size="small" style="margin-left: 20px;" @click="hidehuihuaDialog">取消</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="countrycodeselector" value-key="label2" @cancel="hideshowPicker" @confirm="changecountrycodeselector"/>
    </van-popup>
    <van-popup class="zhWrap" v-model="showzhWrap" position="top">
      <!-- downvalList -->
      <ul class="mydownvalsList">
        <li v-for="item in downvalList" :key="item.id" @click="itemacal(item)">
          <div>
            <img class="userImg userImg3" v-if="item.headurl" :src="item.headurl + '?vs=' + nowTime">
            <p v-else class="userImg userImg3">{{ item.username ? item.username.slice(0, 2) : '-' }}</p>
            <div>
              <p class="blod">{{ item.username }}</p>
              <p class="dan">+ {{ item.areacode }} {{ item.telephone }}</p>
            </div>
          </div>
          <van-tag v-show="item.NoReadCount > 0" :plain="false" size="mini" class="newMessage">新消息</van-tag>
        </li>
      </ul>
      <p class="haomatips">如需管理号码，请在PC端操作</p>
    </van-popup>
    <section v-show="qiehuancheckbox" class="shanchuWrap">
      <van-button type="danger" @click="shifoushanchuFn">删除会话</van-button>
    </section>
  </div>
</template>
<script>
// import { Toast } from 'vant-green'
import { Dialog, Toast } from 'vant-green'
import templateLanguagesObject from '../assets/templateLanguages/templateLanguages'
import requesObj from '../script/publicUrl'
import {WhatsAppChatTelephonesList, WhatsAppCustomerTelephonesList, WhatsAppTagList, WhatsAppCustomerTelephonesDelete, WhatsAppCustomerTelephonesAdd} from '../http/api'
export default {
  data () {
    return {
      IsSelf: null,
      showzhWrap: false,
      countrycodeselector: [],
      wscount: 0,
      count: 0,
      plText: '批量管理',
      qiehuancheckbox: false,
      WhatsAppCustomerTelephonesAddData: {
        Isverify: 0,
        TelephoneId: 0,
        AreaCode: 86,
        Telephone: ''
      },
      aad: null,
      redTips: false,
      nowTime: 0,
      active: 0,
      value1: 0,
      myhadletx: '',
      downvalue: '',
      nowusername: '',
      downvalList: [],
      huihuaDialog: false,
      WhatsAppChatTelephonesListData: {
        Module: 1
      },
      telephonevalue: {
        Module: 1,
        TelephoneId: '',
        TagId: 0,
        Name: '',
        IsRead: 1,
        CustomerTelephone: '',
        PageIndex: 1,
        PageSize: 1000
      },
      checked: false,
      telephonevalList: [],
      checkList: ['1', '2', '3', '4', '5'],
      shijicheckList: ['1', '2', '3', '4', '5'],
      chatListval: {
        TelephoneId: '',
        CustomerTelephoneId: '',
        BeforeSmsId: 0,
        ChatNum: 8
      },
      oldmagg: [],
      magg: [],
      topTagList: [],
      huihuasetingDialog: false,
      WhatsAppCustomerTelephonesSetTranslatesData: {
        Id: '',
        Translates: {
          client: '',
          me: ''
        }
      },
      TelephoneId: 0,
      shaixuanDialog: false,
      chkedAry: [],
      shaixuanTagId: 0,
      show2: false,
      result: [],
      WhatsAppCustomerTelephonesDeleteData: {
        CustomerTelephoneIdList: [],
        TelephoneId: 0
      },
      showPicker: false,
      WhatsAppCustomerTelephonesSetNoReadData: {
        TelephoneId: 0,
        CustomerTelephoneId: 0
      }
    }
  },
  methods: {
    huoqucontent (val, index) {
      // 记录修改的item 下标
      console.log(val)
      this.nowTime = new Date().getTime()
      if (index !== null && index !== undefined) {
        this.changeIndex = index
      }
      this.userheadurl = val.headurl
      // this.WhatsAppCustomerTelephonesUpdateData.TagIdList = val.TagAll
      // _this.qzmoban = false
      if (val.hasOwnProperty('messageid') && val.hasOwnProperty('smsid')) {
        if (val.content.Type === 'TEMPLATE') {
          val.content.Type = val.content.Type.toUpperCase()
          // 变量显示
          val.variableAry = []
          if (val.content.headVariable) {
            val.content.headContent = val.content.headContent.replace('<span title = +\"$(' + val.content.headVariable.Code + ')\" class=\'BianLiang\'>' + val.content.headVariable.Name + '</span>', '<span title="${' + val.content.headVariable.Code + '}" class="BianLiang">' + val.content[val.content.headVariable.Code] + '</span>') // eslint-disable-line
          }
          if (val.content.bodyVariable) {
            for (let a = 0; a < val.content.bodyVariable.length; a++) {
              let aa = this.eval('/\\$\\(' + val.content.bodyVariable[a].Code + '\\)/g')
              val.content.mainBody = val.content.mainBody.replace(val.content.mainBody.match(aa), '<span title="${' + val.content.bodyVariable[a].Code + '}" class="BianLiang">' + val.content[val.content.bodyVariable[a].Code] + '</span>')
            }
          }
        }
        this.msgList.push(val)
        // 发完消息之后滚动条直接滚动到最下面
        // this.$nextTick(() => {
        //   const scrollEl = this.$refs.getHeight
        //   scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
        // })
        // 发送的消息改变左边列表最后一条消息内容显示
        this.telephonevalList.forEach(res => {
          if (res.telephone === val.topphone) {
            res.smslatesttime = val.sendtime
            if (val.content.Type === 'TEMPLATE') {
              // res.content = val.content.headContent
              res.content = '模板'
            } else if (val.content.Type === 'IMAGE') {
              res.content = '图片'
            } else if (val.content.Type === 'DOCUMENT') {
              res.content = '文件'
            } else if (val.content.Type === 'AUDIO') {
              res.content = '音频'
            } else if (val.content.Type === 'VIDEO') {
              res.content = '视频'
            } else {
              res.content = val.content.Content
            }
          }
        })
        return
      }
      // 账号在切换的时候 未读数量和手动点开数量联动
      if (val.noreadcount > 0) {
        this.downvalList.forEach(res => {
          // 列表的未读被点开了 总数就减去对应的数
          if (val.telephoneid === res.id) {
            res.NoReadCount = res.NoReadCount - val.noreadcount
          }
        })
      }
      if (val.Translates) {
        this.WhatsAppCustomerTelephonesSetTranslatesData.Translates = JSON.parse(val.Translates)
      } else {
        this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.client = ''
        this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me = ''
      }
      this.setdataval = []
      this.chatListval.CustomerTelephoneId = val.id
      this.WhatsAppCustomerTelephonesSetTranslatesData.Id = val.id
      this.hehadletx = val.headurl
      this.topmobileareacode = val.mobileareacode
      this.topCountryCode = val.countrycode
      this.topphone = val.telephone
      this.downvalue1 = val.mobile
      this.topname = val.name
      this.changeCountryName = val.countryname
      this.topeamil = val.email
      this.topcountryname = val.countryname
      this.topcompanyname = val.companyname
      this.topTagList = val.TagAll
      this.leftremark = val.remark
      this.chatListval.BeforeSmsId = 0
      if (val.tagidlist.length > 0) {
        val.tagidlist.forEach(res => {
          this.setdataval.push(this.magg.find(item => item.Id === res))
        })
      }
      // WhatsAppCustomerTelephonesChatList(this.chatListval).then(response => {
      //   if (response.code === 200 && response.result) {
      //     response.result.forEach((element, index) => {
      //       element.isTranslat = false
      //       element.TranslatResult = ''
      //       element.content = JSON.parse(element.content)
      //       if (element.content.hasOwnProperty('Type')) element.content.Type = element.content.Type.toUpperCase()
      //       this.chatListval.BeforeSmsId = element.content.smsid
      //       // 当点击了列表 当前可读数量为0
      //       this.telephonevalList.forEach(res => {
      //         if (res.telephone === val.telephone) {
      //           res.noreadcount = 0
      //         }
      //       })
      //       if (index + 1 === response.result.length) {
      //         this.locdingBeforeSmsId = element.smsid
      //       }
      //       // if (index >= 7) {
      //       //   this.locingtext = this.$t('JiaZaiGengDuo')
      //       // } else {
      //       //   this.locingtext = this.$t('MeiYouGengDuoL')
      //       // }
      //       // 变量显示
      //       element.variableAry = []
      //       if (element.content.headVariable) {
      //         let kong = {}
      //         kong.Name = element.content.headVariable.Code
      //         kong.zw = element.content.headVariable.Name
      //         kong.Value = element.content.headVariable.Example
      //         element.content.headContent = element.content.headContent.replace('<span title =\"$(' + kong.Name + ')\" class=\'BianLiang\'>' + kong.zw + '</span>', '<span title="${' + kong.Name + '}" class="BianLiang">' + element.content[kong.Name] + '</span>') // eslint-disable-line
      //       }
      //       if (element.content.bodyVariable) {
      //         for (let a = 0; a < element.content.bodyVariable.length; a++) {
      //           let kong = {}
      //           kong.Name = element.content.bodyVariable[a].Code
      //           kong.zw = element.content.bodyVariable[a].Name
      //           kong.Value = element.content.bodyVariable[a].Example
      //           let aa = this.eval('/\\$\\(' + kong.Name + '\\)/g')
      //           element.content.mainBody = element.content.mainBody.replace(element.content.mainBody.match(aa), '<span title="${' + kong.Name + '}" class="BianLiang">' + element.content[kong.Name] + '</span>')
      //         }
      //       }
      //     })
      //     this.msgList = response.result.reverse()
      //     this.show2 = true
      //     this.$nextTick(() => {
      //       const scrollEl = this.$refs.getHeight
      //       scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
      //     })
      //   } else {
      //     this.msgList = []
      //     this.show2 = true
      //   }
      // })
      let postData = JSON.stringify(val)
      localStorage.setItem('IsSelf', this.IsSelf)
      localStorage.setItem('client', val.Translates)
      localStorage.setItem('userMsg', postData)
      localStorage.setItem('TelephoneId', this.TelephoneId)
      console.log(this.myhadletx)
      if (this.myhadletx === null) {
        console.log('11')
        localStorage.setItem('myhadletx', this.downvalue)
      } else {
        console.log('22')
        localStorage.setItem('myhadletx', this.myhadletx)
      }
      this.$router.push({path: '/Chat'})
    },
    WhatsAppChatTelephonesListFn () {
      WhatsAppChatTelephonesList({Module: 1}).then(response => {
        if (response.code === 200 && response.result) {
          if (response.result.length <= 0) {
          } else {
            // let moni = {Id: 122, NoReadCount: 10, areacode: '86', headurl: '', showname: '', telephone: '13120956858', username: '测试人员', value: '13120956858', text: '测试人员2'}
            response.result.forEach(element => {
              element.value = element.telephone
              element.text = element.username
            })
            // this.WhatsAppCustomerTelephonesSetNoReadData.TelephoneId = response.result[0].id
            this.WhatsAppCustomerTelephonesAddData.TelephoneId = response.result[0].id
            this.WhatsAppCustomerTelephonesDeleteData.TelephoneId = response.result[0].id
            // this.leftusername = response.result.length > 0 ? response.result[0].username : ''
            this.downvalue = response.result.length > 0 ? response.result[0].username : ''
            this.downvalue1 = response.result.length > 0 ? response.result[0].telephone : ''
            this.nowusername = response.result.length > 0 ? response.result[0].username : ''
            localStorage.setItem('fuzeren', response.result[0].username)
            localStorage.setItem('newtelephone', response.result[0].areacode + response.result[0].telephone)
            // this.newtelephone = response.result.length > 0 ? response.result[0].telephone : 0
            // this.ipnewtelephone = response.result.length > 0 ? response.result[0].areacode : ''
            this.telephonevalue.TelephoneId = response.result.length > 0 ? response.result[0].id : ''
            this.TelephoneId = response.result[0].id
            // this.chatListval.TelephoneId = response.result.length > 0 ? response.result[0].id : ''
            this.myhadletx = response.result.length > 0 ? response.result[0].headurl : ''
            // response.result.push(moni)
            this.downvalList = response.result
            this.IsSelf = response.result[0].IsSelf
            this.listchat()
          }
        }
      })
    },
    itemacal (val) {
      this.WhatsAppCustomerTelephonesAddData.TelephoneId = val.id
      this.WhatsAppCustomerTelephonesSetNoReadData.TelephoneId = val.id
      this.WhatsAppCustomerTelephonesDeleteData.TelephoneId = val.id
      const dataval = this.downvalList.filter(item => item.id === val.id)
      this.telephonevalue.TelephoneId = dataval[0].id
      this.chatListval.TelephoneId = dataval[0].id
      this.newtelephone = dataval[0].telephone
      this.ipnewtelephone = dataval[0].areacode
      this.downvalue = dataval[0].username
      this.myhadletx = dataval[0].headurl
      this.downvalue1 = dataval[0].mobile
      this.IsSelf = dataval[0].IsSelf
      this.show2 = false
      this.showzhWrap = false
      localStorage.setItem('newtelephone', this.areacode + this.ipnewtelephone)
      this.listchat()
    },
    showhuihuaDialog () {
      this.WhatsAppCustomerTelephonesAddData.AreaCode = 86
      this.WhatsAppCustomerTelephonesAddData.Telephone = ''
      this.redTips = false
      this.huihuaDialog = true
    },
    changeOption (item) {
      alert('修改后记得重置缓存里的负责人')
      this.$refs.custom.toggle()
      console.log(item)
      // this.inlineOption = options
      // this.inlineOption.map(item => {
      //   console.log(item.options.filter(obj => obj.checked))
      // })
    },
    // 聊天列表
    listchat () {
      if (this.downvalList.length === 0) {
        return
      }
      this.telephonevalue.TagId = this.allbq
      if (this.checked) {
        this.telephonevalue.IsRead = 1
      } else {
        this.telephonevalue.IsRead = 0
      }
      this.WhatsAppCustomerTelephonesListFn()
    },
    WhatsAppCustomerTelephonesListFn () {
      WhatsAppCustomerTelephonesList(this.telephonevalue, 'has').then(response => {
        if (response.code === 200 && response.result) {
          this.telephonevalList = []
          for (let a = 0; a < response.result.length; a++) {
            response.result[a].TagAll = []
            response.result[a].shanchuhuihuaWrapFlag = false
            for (let b = 0; b < response.result[a].tagidlist.length; b++) {
              for (let c = 0; c < this.oldmagg.length; c++) {
                if (response.result[a].tagidlist[b] === this.oldmagg[c].Id) {
                  let kong = {}
                  kong.name = this.oldmagg[c].Name
                  kong.Id = this.oldmagg[c].Id
                  response.result[a].TagAll.push(kong)
                }
              }
            }
          }
          this.telephonevalList = response.result
          this.telephonevalList.forEach(res => {
            res.smslatesttime = this.$formatDate(new Date(res.smslatesttime), 'yyyy-MM-dd hh:mm:ss')
            res.messagecont = 0
          })
          if (this.telephonevalList.length === 0) {
            this.show2 = false
          }
          this.massageList()
        } else {
          this.telephonevalList = []
          this.show2 = false
        }
      })
    },
    futerDataFn (flag) {
      if (flag === '全部') {
        this.checked = false
      } else {
        this.checked = true
      }
      this.listchat()
    },
    massageList () {
      const data = {
        Keyword: '',
        PageIndex: 1,
        Module: 1,
        PageSize: 1000
      }
      // this.biaoqianloading = true
      WhatsAppTagList(data, 'has').then(response => {
        this.biaoqianloading = false
        if (response.code === 200 && response.result && response.result.length > 0) {
          response.result.forEach(res => {
            res.status = false
            res.clickType = 'add'
          })
          this.oldmagg = JSON.parse(JSON.stringify(response.result.reverse()))
          this.magg = JSON.parse(JSON.stringify(response.result.reverse()))
        }
      })
    },
    changetabbar () {
      console.log(this.active)
      if (this.active === 1) {
        this.$router.push({path: '/Personal'})
      }
    },
    showhuasetingDialogFn () {
      if (this.downvalList.length === 0) {
        return
      }
      this.huihuasetingDialog = true
      this.checkList = this.shijicheckList
    },
    huihualiebiaoShezhi () {
      this.huihuasetingDialog = false
      this.shijicheckList = this.checkList
      localStorage.setItem('checkList', JSON.stringify(this.checkList))
    },
    showshaixuanDialog () {
      if (this.downvalList.length === 0) {
        return
      }
      this.shaixuanDialog = true
    },
    checkedTagFn2 (item) {
      this.nodeFlag = false
      this.shaixuanTagId = item.Id
    },
    clearTagary () {
      // for (let a = 0; a < this.shaixuanAry.length; a++) {
      //   this.shaixuanAry[a].type = 2
      //   for (let b = 0; b < this.shaixuanAry[a].taglist.length; b++) {
      //     this.shaixuanAry[a].taglist[b].color = null
      //   }
      // }
      this.shaixuanTagId = 0
      // this.saveDialog2 = null
      // this.nodeFlag = false
      // // this.contacterlistData.TagSelectEntityList = []
    },
    shaixuanButton2 () {
      this.telephonevalue.TagId = this.shaixuanTagId
      this.shaixuanDialog = false
      this.WhatsAppCustomerTelephonesListFn()
    },
    changegroup () {
      // console.log(this.result)
    },
    plFn () {
      if (this.downvalList.length === 0) {
        return
      }
      if (this.qiehuancheckbox === true) {
        this.plText = '批量管理'
        this.qiehuancheckbox = false
      } else {
        this.qiehuancheckbox = true
        this.result = []
        this.plText = '取消批量管理'
      }
    },
    shifoushanchuFn () {
      let _this = this
      Dialog.confirm({
        message: '确认删除会话?',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        // on confirm
        console.log('confirm')
        _this.WhatsAppCustomerTelephonesDeleteFn()
      }).catch(() => {
      })
    },
    WhatsAppCustomerTelephonesDeleteFn () {
      this.WhatsAppCustomerTelephonesDeleteData.CustomerTelephoneIdList = this.result
      WhatsAppCustomerTelephonesDelete(this.WhatsAppCustomerTelephonesDeleteData, 'has').then(response => {
        if (response.code === 200) {
          Toast('操作成功')
          this.qiehuancheckbox = false
          this.result = []
          this.listchat()
        }
      })
    },
    // websocket
    initWebSocket () {
      console.log('初始化weosocket')
      // const wsuri = 'ws://testappapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.sessionStorage.getItem('token')
      let wsuri
      if (requesObj.requestUrl === 'http://testappapi.tradepower.net') {
        wsuri = 'ws://testappapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.localStorage.getItem('flagMig')
      } else {
        wsuri = 'wss://vipapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.localStorage.getItem('flagMig')
      }
      // wsuri = 'ws://testappapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.localStorage.getItem('flagMig')
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen (e) {
      console.log('websoket开启')
      // 连接建立之后执行send方法发送数据
      this.websocketsend()
      // let actions = {'user': 'c9PQ5Q_XbVdhwaYj9bBHmNQ36kC2i5190DXwSkuY_G9Kq7F6geEooqECBLxiVQ7YqrmiZTye5OJ3BqIbYRYVctxJ24qJpRdYLczXeMR0TRX416AcJymttNwer6G4R_CKQjmhpbTCOBQlmEa4Rv088XIIOiVKFGyVtaiKdXd0Hw5q2mcj3dTD2hqOPrFaY5r9'}
      // this.websocketsend(JSON.stringify(actions))
    },
    websocketonerror () { // 连接建立失败重连
      console.log('websoket连接建立失败重连')
      this.wscount += 1
      if (this.wscount < 3) {
        this.initWebSocket()
      } else {
        return
      }
      this.textlinkdk = '(链接已断开)'
    },
    websocketonmessage (e) { // 数据接收
      console.log(e)
      let _this = this
      _this.textlinkdk = ''
      if (e && e.data) {
        _this.tosocketonmessage = JSON.parse(e.data)
        if (_this.tosocketonmessage.type === 11) {
          if (_this.tosocketonmessage.isexist === 1) {
            _this.WhatsAppCustomerTelephonesAddData.Isverify = 1
            _this.WhatsAppCustomerTelephonesAddFn('has')
          } else {
            _this.redTips = true
          }
          return
        }
        if (_this.tosocketonmessage.type === 10) {
          _this.tomessage = JSON.parse(JSON.parse(e.data).message)
          // 当前页面来了消息
          console.log('当前来信息的时候topphone:' + _this.topphone)
          // if (_this.topphone === _this.tomessage.to && _this.tomessage.from === _this.ipnewtelephone + _this.newtelephone) {
          //   _this.msgList.push({content: _this.tomessage, issend: false, messageid: '', smsid: _this.locdingBeforeSmsId, sendtime: this.$formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'), isTranslat: false, TranslatResult: false})
          //   this.$nextTick(() => {
          //     const scrollEl = this.$refs.getHeight
          //     scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
          //   })
          // }
          // console.log(_this.ipnewtelephone + _this.newtelephone)
          // if (_this.tomessage.from === _this.ipnewtelephone + _this.newtelephone) {
          //   let dontHasItem = false
          //   if (this.telephonevalList.length === 0) {
          //     this.WhatsAppCustomerTelephonesListFn('has')
          //   } else {
          //     for (let a = 0; a < this.telephonevalList.length; a++) {
          //       if (this.telephonevalList[a].telephone !== _this.tomessage.to) {
          //         dontHasItem = true
          //         break
          //       }
          //     }
          //     console.log(dontHasItem)
          //     if (dontHasItem === true) {
          //       this.WhatsAppCustomerTelephonesListFn('has')
          //     }
          //   }
          // }
          // 除了我别的人员来了消息
          _this.telephonevalList.forEach(res => {
            if (res.telephone === _this.tomessage.to) {
              res.noreadcount += 1
              if (_this.tomessage.Type === 'TEMPLATE') {
                res.content = '模板'
              } else if (_this.tomessage.Type === 'IMAGE') {
                res.content = '图片'
              } else if (_this.tomessage.Type === 'DOCUMENT') {
                res.content = '文件'
              } else if (_this.tomessage.Type === 'AUDIO') {
                res.content = '音频'
              } else if (_this.tomessage.Type === 'VIDEO') {
                res.content = '视频'
              } else {
                res.content = _this.tomessage.Content
              }
            }
          })
          // 解决点击的页面后端总数的问题
          // if (_this.tomessage.from === _this.ipnewtelephone + _this.newtelephone && _this.topphone === _this.tomessage.to) {
          //   const dataval = {
          //     TelephoneId: _this.chatListval.TelephoneId,
          //     CustomerTelephoneId: _this.chatListval.CustomerTelephoneId
          //   }
          //   WhatsAppCustomerTelephonesChatReaded(dataval, 'has').then(response => {
          //     if (response.code === 200 && response.result) {}
          //   })
          // }
          // 账号总数也+1条
          this.downvalList.forEach(res => {
            // 如果对应的来了消息 给账号加一console.log(_this.newtelephone, _this.tomessage.from.slice(2),res.telephone,this.topphone,_this.tomessage.to)
            // 当前的  _this.newtelephone
            //  来的   _this.tomessage.from.slice(2)
            // 循环的  res.telephone
            // 1 来的和当前  不一样 肯定 +1
            // 2 来的和当前的 一样   a  没选择聊天 +1   b  选择了聊天且聊天不等于to +1
            if (_this.ipnewtelephone + _this.newtelephone !== _this.tomessage.from && _this.tomessage.from === res.areacode + res.telephone) {
              res.NoReadCount = res.NoReadCount + 1
            } else if (_this.ipnewtelephone + _this.newtelephone === _this.tomessage.from && res.areacode + res.telephone === _this.tomessage.from && _this.topphone !== _this.tomessage.to) {
              res.NoReadCount = res.NoReadCount + 1
            }
          })
          // if (this.topphone) {
          //   console.log(this.topphone)
          //   this.$nextTick(() => {
          //     const scrollEl = this.$refs.getHeight
          //     scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
          //   })
          // }
        }
      }
    },
    websocketsend (data) { // 数据发送
      let _this = this
      this.textlinkdk = ''
      _this.aad = setInterval(function () {
        _this.websock.send('前端发送心跳检测' + _this.count)
        _this.count += 1
      }, 60000)
    },
    websocketclose (e) { // 关闭
      // if (this.wscount < 3) {
      //   this.websock.close()
      //   this.initWebSocket()
      // } else {
      //   return
      // }
      console.log('关闭soket')
    },
    changecountrycodeselector (value) {
      console.log(value)
      this.WhatsAppCustomerTelephonesAddData.AreaCode = value.value
      this.showPicker = false
      // picker.setColumnValues(1, citys[values[0]]);
    },
    hideshowPicker () {
      this.showPicker = false
    },
    createWhatsappNumber () {
      if (!this.WhatsAppCustomerTelephonesAddData.Telephone) {
        Toast('请输入手机号')
        return
      }
      this.WhatsAppCustomerTelephonesAddData.Isverify = 0
      this.WhatsAppCustomerTelephonesAddFn('none')
    },
    WhatsAppCustomerTelephonesAddFn (type) {
      WhatsAppCustomerTelephonesAdd(this.WhatsAppCustomerTelephonesAddData).then(response => {
        if (response.code === 200) {
          if (this.WhatsAppCustomerTelephonesAddData.Isverify === 1) {
            this.huihuaDialog = false
          }
          if (type !== 'none') {
            this.listchat()
            let dom = document.querySelector('#infoList')
            let dom1 = dom.querySelectorAll('li')
            if (dom.length > 0) {
              setTimeout(function () {
                var event
                event = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true
                })
                dom1[0].dispatchEvent(event)
              }, 1500)
            }
          } else {
            //  流程是创建会话后在soket里接收结果，然后通过soket结果里处理相关逻辑
            Toast('正在发起会话,请稍等！')
          }
          // Message.success('正在发起会话中，请稍等!')
        }
      })
    },
    hidehuihuaDialog () {
      this.huihuaDialog = false
    }
  },
  mounted () {
    let datas = localStorage.getItem('flagMig')
    if (!datas) {
      this.$router.push({name: 'login'})
      return
    }
    this.initWebSocket()
    this.nowTime = new Date().getTime()
    var sd = localStorage.getItem('checkList')
    if (sd && sd !== 'null') {
      this.checkList = JSON.parse(sd)
      this.shijicheckList = JSON.parse(sd)
    }
    let getcountrycodeselector = templateLanguagesObject.countrycodeselector
    getcountrycodeselector.forEach(function (item) {
      item.label2 = item.label + item.value
    })
    this.countrycodeselector = getcountrycodeselector
    this.massageList()
    this.WhatsAppChatTelephonesListFn()
  },
  beforeDestroy () {
    if (this.websock) {
      console.log('beforeDestroy前退出socket')
      clearInterval(this.aad)
      this.websock.close()
    }
  }
}
</script>
<style scoped>
#home{color: #303133;}
#home>div:nth-child(1),#home>div:nth-child(2){padding: 6px;}
.main1,.main2{border-bottom: 1px solid #E1E5ED;}
.main2{padding-bottom: 14px!important; }
.selectWrap{display: flex;align-items: center;margin-bottom: 8px;}
.selectWrap img{margin-right: 4px;}
.userImg{width: 40px;height: 40px;border-radius: 50%;color: #fff;background-color: #23C7D9;text-align: center;line-height: 40px;margin-right: 8px;}
.userImg1{width: 40px;height: 40px;border-radius: 50%;color: #fff;text-align: center;line-height: 40px;}
.userImg2{width: 40px;height: 40px;border-radius: 50%;color: #fff;text-align: center;line-height: 40px;margin-right: 16px !important;}
.userImg3{margin-right: 10px !important;}
.blod{font-size: #303133;font-size: 16px;margin-bottom: 4px;font-weight: bold;}
.dan{font-size: #919499;}
.sm_Wrap{display: flex;align-items: center;margin: 4px 0 12px 0;}
.sm_Wrap>div{flex: 1;}
.sm_Wrap>img{margin-left: 8px;padding: 8px;background-color: #F2F4F7;border-radius: 50%;}
.plWrap{width: 96%;margin: 0 auto;display: flex;align-items: center;justify-content: space-between;}
.infoList{color: #909399;overflow-y: auto;height: calc(100% - 202px);margin-bottom: 60px;}
.infoName{display: flex;align-items: center;justify-content: space-between;margin-bottom:2px !important;}
.infoList li{display: flex;padding: 12px;cursor: pointer;transition: all .3s;}
.infoList li:hover{background-color: #e7e9e9 !important;}
.infoList li>p{flex-shrink: 0;margin-right: 16px;}
.infoList li>div{position: relative;}
.infoList li>div>p:not(:last-child){margin-bottom: 8px;}
.infoList li>div>p{display: flex;align-items: center;}
.infoList img{margin-right: 6px;display: inline-block;}
.infoList li:not(:last-child){border-bottom: 1px solid #E1E5ED;}

.smTags{margin-right:4px}
#liebiaoshezhi{width: 80%;padding: 10px 20px 20px 20px;border-radius: 8px;}
.mycheckList>div{margin-top: 8px;}
.myipt{height: 48px;}
.myipt>div{height: 30px !important;line-height: 30px !important;}
/* .sp_button{transform: translate(-20px, 0);} */
.vans-button>button{border: 0 !important;}
.fanyidialogitem1{display: flex;justify-content: space-between;align-items: center;padding: 8px 4px;color: #333;font-weight: bold;font-size: 14px;margin-top: 0 !important;}
.fanyidialogitem2>p{color: #919499;margin: 14px 0 6px 0;}
.fanyidialogitem2>section{padding: 8px 14px;background-color: #F2F4F7;border-radius: 4px;display: flex;align-items: center;justify-content: space-between;}
.jjWraps{display: flex;align-items: center;border-bottom: 0 !important;margin: 14px 0;}
.jjWraps>button{flex: 1;}
.TagDialog{width: 90%;margin: 0 auto;max-height: 80%;border-radius: 4px;padding: 8px;}
.tagsWraps{padding: 0 2%;border-bottom: 0 !important;margin-top: 12px !important;}
.tagsWraps>span{margin:0 8px 8px 0;cursor:pointer}
.red{color: red;height: 16px;margin-top: 6px;}
.isEmpit{text-align: center;}
.isEmpit>img{margin: 160px auto 0;}
.isEmpit>p{font-size: 16px;color: #303133;font-weight: bold;margin-top: 20px;}
.grenn{color: #0283ef;}
.shanchuWrap{position: fixed;left: 0;bottom: 0;background-color: #fff;width: 100%;z-index: 9999;padding: 30px 0;}
.shanchuWrap>button{width: 80%;margin: 0 auto;display: block;}
.redreidw {
  display: inline-block;
  color: #fff;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: #E6723C;
  border-radius: 50%;
  margin-top: 7px;
  font-size: 10px;
  margin-left: 16px;
}
.infoMsg{position: relative;}
.redreidw1{margin-top: 0 !important;position: absolute;right: -60px;top: 0;}
.shoujihaoWrap{display: flex;align-items: center;}
.shoujihaoWrap>span{margin-right: 8px;border: 1px solid #ccc;border-radius: 4px;width: 48px;text-align: center;height: 36px;line-height: 36px;}
.shoujihaoWrap>div{border: 1px solid #ccc;padding: 6px 4px;width: 240px;border-radius: 4px;}
.mydownvalsList{padding: 10px 0;}
.mydownvalsList>li{display: flex;padding: 10px 20px;justify-content: space-between;align-items: center;border-bottom: 1px solid #F2F4F7;}
.mydownvalsList>li>div{display: flex;}
.haomatips{text-align: center;margin-bottom: 10px;}
.newMessage{background-color: red;color: #fff;border-radius: 10px;font-size: 10px;padding: 2px 4px!important;}
.vector{vertical-align: middle;margin-left: 4px;}
</style>



// WEBPACK FOOTER //
// src/view/home.vue